import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const CCLLop = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Laws of Property here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',transform: 'translate(0%, -9%)'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>At <span className="kwa">KWA</span>, we specialize in providing premier legal representation in both <span
                className="highlight">criminal and civil litigation</span> pertaining to <span className="highlight">property
                law</span>. We recognize the complexities and importance of property-related disputes, whether they
            involve <span className="highlight">real estate transactions</span>, <span className="highlight">property
                rights</span>, <span className="highlight">landlord-tenant conflicts</span>, or <span
                className="highlight">allegations of property crimes such as fraud and theft</span>.</p>
        <br />
        <p>Our team of seasoned attorneys is committed to safeguarding our clients' property interests through thorough 
            <span className="highlight">legal analysis</span>, <span className="highlight">strategic planning</span>, and <span
                className="highlight">vigorous advocacy</span>. We are adept at navigating the intricate legal framework of
            property law with the utmost professionalism and precision, ensuring that our clients receive comprehensive
            support and effective resolutions to their legal issues.</p>
        <br />
        <p>Our firm is equipped to offer robust and assertive legal services, meticulously tailored to meet the unique
            requirements of each case. We strive to secure the most favorable outcomes for our clients by delivering
            customized legal strategies and unwavering dedication.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default CCLLop
